// extracted by mini-css-extract-plugin
export default {"animatedButton":"StyleCustomButton_animatedButton__lAFy4"};